import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config/config";

export const collectionsQuery = [
  {
    heading: "Main Character Wardrobe",
    query: "All brands ramadan and eid Eastern wear collection for women",
  },
  {
    heading: "The Gentleman’s Wardrobe",
    query: "Eid dresses for men",
  },
  {
    heading: "Outfit Incomplete Without This",
    query: "Sandles from eid collection",
  },
  {
    heading: "Step Up Your Style",
    query: "Shoes for men for eid",
  },
  {
    heading: "Little Gentlemen Vibes",
    query:
      "Eid dress for kids boys mixed brands j. edenrobe cambridge diners and more",
  },
  {
    heading: "Tiny Queens Collection",
    query: "Eid dress for kids girls",
  },
  {
    heading: "Level Up the Look",
    query: "Accessories for men",
  },
  {
    heading: "Glam Add-Ons",
    query: "Accessories for her for eid",
  },
];

export const fetchCollections = createAsyncThunk(
  "collections/fetchCollections",
  async (_, { rejectWithValue }) => {
    try {
      let search = [];

      collectionsQuery.forEach((item) => {
        search.push(item.query);
      });

      const response = await axios.get(
        `${config.backendUrl}/inventory/batch_search`,
        {
          params: { q: search },
        },
      );

      return response.data?.results?.responses || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch collections",
      );
    }
  },
);

const initialState = {
  collections: [],
  loading: false,
  error: null,
};

const collectionsSlice = createSlice({
  name: "collections",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCollections: (state) => {
      state.collections = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCollections.fulfilled, (state, action) => {
        state.loading = false;
        state.collections = action.payload;
      })
      .addCase(fetchCollections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearCollections } = collectionsSlice.actions;
export default collectionsSlice.reducer;
